import Overview from './pages/Overview.jsx';
import React from 'react';
import Subscription from './pages/Subscription.jsx';
import {Route, Switch} from 'react-router-dom';

export default function Routes() {
  return (
    <Switch>
      <Route
        path={[
          '/subscription/:subscriptionId/(.*)',
          '/subscription/:subscriptionId',
        ]}
      >
        <Subscription />
      </Route>
      <Route path="/">
        <Overview />
      </Route>
    </Switch>
  );
}
